import { div } from "framer-motion/client";
import { useRef } from "react";
import VolumeIcon from "./VolumeIcon";

const AudioPlayer = ({audio_url}) => {
    const audioRef = useRef(null)

    function handlePlay(){
        if(audioRef.current) audioRef.current.play()
    }

    return (
        <div>
            <button 
            style={{
                backgroundColor: '#FFD64D',
                color: 'white',
                padding: '10px 20px',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                fontSize: '16px',
                transition: 'background-color 0.3s ease'
            }}  
            onClick={handlePlay}>
                <VolumeIcon/>
            </button>
            <audio ref={audioRef} src={audio_url} preload="auto"/>
        </div>
    )
};

export default AudioPlayer